import moment from "moment";
export const isServerEnv=  true;
//export const rooturl="http://testapi.lagosjudiciary.gov.ng";
/* export const rooturl=isServerEnv?"https://jisapi.justwebtech.com": "https://localhost:7050";*/
/* export const rooturl=isServerEnv?"https://jisapi.justwebtech.com": "https://localhost:7050";
export  const baseurl=isServerEnv?"https://jisstaging.justwebtech.com" : 'http://localhost:3000'; */
export const rooturl=isServerEnv?"https://apistaging2.lagosjudiciary.gov.ng": "https://localhost:7050";
export const baseurl=isServerEnv?"https://jisstaging2.lagosjudiciary.gov.ng" : 'http://localhost:3000'; 


export const primarySite="https://jisstaging2.lagosjudiciary.gov.ng";
export const primary_doc_file=`${primarySite}/CaseDocuments`;
export const pay4it_key="TEST-Key-670664575316be1f4dc68994";
export const payment_callback=`${baseurl}/confirm-pay`
export const payment_callback_internal=`${baseurl}/confirm-internal`
export const Motion_Application_Substituted_Service=14;
export const Motion_Application_Default_Judgement =15;
//document.documentElement.setAttribute('data-theme', 'dark'); //change Theme to dark

export const apiUrl=`${rooturl}/api`;
export const docUrl=`${rooturl}/resources/`;
export const lastSpecified="52500.00"; //casetype_component 736

export const CFO_Placeholders = new Set([12,24,26,27,65]); 

export const paystack_public="pk_test_657c8b8312c24ace7419a954beac2b8f4c43e65f";
export const Affidavit_Role_id=6;
export const Legal_Role_id=1;
export const Non_Legal_Role_id=2;
export const Default_State = 15; //lagos
export const ClaimantType=1;
export const DefendantType=4;
export const PAGESIZE=10;

export const CategoryList=[
  {id:1,title:'GENERAL CIVIL'},
{id:2,title:"LANDS"},
{id:6,title:"FAMILY AND PROBATE (DIVORCE, PURE PROBATE AND CUSTODY)"},
{id:14,title:"BAIL APPLICATION"},{id:7,title:"FUNDAMENTAL HUMAN RIGHT"},
{id:15,title:"GRANTING LEAVE TO FILE DIVORCE"},
{id:16, title:"JUDICIAL REVIEW"},
{id:3,title:"CRIMINAL"},{id:3,title:"CRIMINAL"},
{id:4,title:"COMMERCIAL"},{id:9,title:"MORTGAGES AND REVENUE"}];
export const formatDateTime=(inputDateTime)=> {
    const options = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    };
  
    const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(new Date(inputDateTime));
    return formattedDateTime;
  }
  export const formatDate=(inputDateTime)=> {
    const options = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    
      hour12: true,
    };
  
    const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(new Date(inputDateTime));
    return formattedDateTime;
  }
  export const formatTime=(inputDateTime)=> {
    const options = {
     
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    };
  
    const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(new Date(inputDateTime));
    return formattedDateTime;
  }

  export const duration=(timespan)=>{
    if(timespan!=null){
      let [days, hms] = timespan.split(".");
      if(days==null){
        let [hours, minutes, seconds] = timespan.split(":").map(Number);
        return `${days}Day ${hours}:${minutes}`
      }else{
          let [hours, minutes, seconds] = hms.split(":").map(Number);
         return `${days}Day ${hours}hr ${minutes}min`
      }
}else{
      return '';
    }
  }

  export const formatCurrency = (value) => {
  if (value == null) return '';

  // Keep the negative sign if present
  const numeric = value.toString().replace(/[^0-9.-]/g, "");

  const number = parseFloat(numeric);
  if (isNaN(number)) return "";

  return number.toLocaleString("en-US");
};

  export const dateOnly=(value) =>{
    let dstring=  moment(value).format("YYYY-MM-DD");
    return dstring;
    //let d=new Date(dstring);
    //return d;
   }

   export function seo(data = {}) {
    data.title = data.title || 'Lagos Judiciary';
    data.metaDescription = data.metaDescription || 'Lagos Judiciary';
  
    document.title = data.title;
    document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
  }
  export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    if(file){
      reader.readAsDataURL(file);
    }
   // reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});
export const getCookie=(key) => {
  var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
  return b ? b.pop() : "";
}
export const AbsoluteFiletoRelative=(absolutepath)=>{
   //first split from last appearance of resources
   if(absolutepath==null)
   return '';
  
  var tn= absolutepath.split("Resources");
  var relative= apiUrl. slice(0, -3) +"Resources"+tn[1].replace(/\\/g, "/");
  console.log('the file relative path')
  console.log(relative);
  return relative;
  
}
export const RelativeFiletoRelative=(relativepath)=>{
   //first split from last appearance of resources
   if(relativepath==null)
   return '';
  
  var relative= docUrl+relativepath;
  return relative;
  
}
export const ReduceFilename=(filename)=>{
  if(filename.length>25){
   var aa= filename.split('.');
   if(aa.length==2){
     //exact senerio
    var nn= aa[0].substring(0,20)+"."+aa[1];
    return nn;
   }else{
     return aa[0]+"."+aa[aa.length-1];
   }
  }else{
  return filename;
  }
}

export const ReduceString=(value, max)=>{
  if(value==null)
    return '';
  
  if(value.length>max){
     var s=value.substring(0,max)
    return s+'...';
  }else{
  return value;
  }
}
export const NoteExcept=(title)=>{
 return  title?.startsWith('NOTE');
}
const formatter = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'NGN',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

export const RewriteLocalUrl=(localurl)=>{
  let res =localurl.indexOf("Resources");
  let s =localurl.substring((res), localurl.length);
  return ( `${rooturl}/`+s);
}

export const CalUnSpecified =(bignumber)=>{
  var fixincamt="5000000";
  var incrementval = "2500";
  var difffromstart = "100000000";
  var diff = bignumber - difffromstart;
  var res = 0;
  var finalamt = 0;
  res = diff / fixincamt;
  //res = Math.floor(res);
  if (res > 0) {
      if (res <= 1) {
          finalamt = 1 * parseInt(incrementval);
      }
      else {
          finalamt = Math.ceil(res) * parseInt(incrementval);
      }
  }
  else {
      finalamt = 0;
  }

  var feeamount= lastSpecified //element 736 last value
 var calunspefamount = parseInt(feeamount) + parseInt(finalamt);
  return calunspefamount;
}

export const isNumber=(value)=> {
//console.log(`${typeof value} and the isNAN ${!Number.isNaN(value)}`)
  return  !Number.isNaN(value);

}
export const Distinct=(arr)=>{
  return Array.from( new Set( arr ) ) ;
}

export const ReplaceAll=(str,str1, str2,)=>
{
 //return str.replace(/replaceWhat/g,replaceTo);
const ignore=true;
  return str.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), (ignore ? "gi" : "g")), (typeof(str2) == "string") ? str2.replace(/\$/g, "$$$$") : str2);

}
export const CleanQuillHtml=(html)=>{
//replace all class="ql-align-center" to style="text-align:center"
// class="ql-align-right" style="text-align:right"
}
/* export const DocPermissionList =new Set([
  182,183,184,685, 189,196,702,707,196,693,703,
  708,712,713,714,189, 244,261,570,441,312,
   22,25,38,64 //680 //remove 680 on live
])  */
export const DocPermissionList =new Set([
  183,703,707,196,200,189,243,278,693,257,576,447,318,261,576,447,318,583,454,325,
  587,458,329, 15,16,22,25,35,38,39
]) 

export const DocPermissionList_ADR =new Set([
  42,46,55,58,88,89,101,105,119,127,147,149,154,157,158,179
]) 
export const getAlphaByNum=(n)=>{
  return String.fromCharCode(96 + n); //a is 96
}
export const getQueryString=(variable)=>
{
        var query = window.location.search.substring(1);
        console.log(query)//"app=article&act=news_content&aid=160990"
        var vars = query.split("&");
        console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
        for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
        if(pair[0] == variable){return pair[1];}
         }
         return(false);
}
export const getQuery=()=>
{
        var query = window.location.search.substring(1);
        console.log(query)//"app=article&act=news_content&aid=160990"
      
         return(query);
}
export const Checkfiles=(fileName)=>
        {
        //var fup = document.getElementById('filename');
        //var fileName = fup.value;
        var ext = fileName.substring(fileName.lastIndexOf('.') + 1);
        if(ext == "pdf" )
        {
        return true;
        } 
        else
        {
       
        return false;
        }
        }
      export const b64encode = (txt)=> { 
          return btoa(unescape(encodeURIComponent(txt))); 
      };
      export const b64decode = (txt) =>{ 
          return decodeURIComponent(escape(atob(txt))); 
      };

export const decodeBase64ToUtf8=(base64)=> {
  // Convert base64 → binary string
  const binary = atob(base64);

  // Convert binary string → bytes
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  // Decode bytes as UTF-8 text
  return new TextDecoder("utf-8").decode(bytes);
}

      export const  ConvertText=(str)=>{
       // return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
       return str.replace(/[^\x00-\x7F]/g, "");
      }

      export const QrCodelink=(str)=>{
        return `https://quickchart.io/qr?text=${str}&size=100`;
      }

      export const TitleCase=(str)=>{
        return str[0].toUpperCase() + str.slice(1).toLowerCase();
      }
      export const serverErr="Could not connect to the service at the moment. Please try again.";
export const IsNull=(v)=>{
  if(v==undefined || v==null)
    return true;
  else
  return false;
}

export const onScreenDetails= async(code,token)=>{
    //for account registration
    try {
 
        const resp = await fetch(`${apiUrl}/profile/screens/${code}`, { 
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        
        const data = await resp.json();
       return data;
       
      } catch (error) {
        console.error(error);
      }
}

export const PageDetails=(data,type,code)=>{
     if(type=="tab"){
        const found = data?.tabs?.find(el => el.code === code);
        return found;
    }else if(type="action"){
        const found = data?.actions.find(el => el.code === code);
        return found;
    }
}
export const upsertObject = (prevObjs, newObj) => {
    const index = prevObjs.findIndex(obj => obj.id === newObj.id);
    if (index !== -1) {
      // Update existing role
      return prevObjs.map(obj => obj.id === newObj.id ? { ...obj, ...newObj } : obj);
    } else {
      // Insert new role
      return [...prevObjs, newObj];
    }
};

export const getItemById = (items,id) => {
  var item=items.find(r => r.id == id);
    return item; 
};

export const getLabelByValue = (items,value) => {
  var item=items.find(r => r.value == value);
    return item?item.label:''; 
};
export const gender=[
        {label:'Male',value:'M'},
        {label:'Female', value:'F'}
    ]
 export const maritalstatus=[
        {label:'Married',value:'M'},
        {label:'Single', value:'S'},
        {label:'Widow/Widower',value:'W'},
        {label:'Divorced', value:'D'}
    ]
/* if (response.ok) {
      // HTTP 200 or 201
      console.log('✅ Success:', result.message);
      // Show success alert or update UI
    } else if (response.status === 409) {
      // Conflict (duplicate)
      console.warn('⚠️ Duplicate:', result.message);
      // Show warning message to user
    } else if (response.status === 400) {
      // Bad request (validation)
      console.error('❌ Validation Error:', result.message);
    } else if (response.status === 404) {
      // Not found
      console.error('❌ Not Found:', result.message);
    } else {
      // Other error
      console.error('❌ Unexpected error:', result.message || 'Unknown error');
    } */

      export const momentDate=(dateinfo)=>{
        if(dateinfo==null){
          return null;
        }
        let time = moment.utc(dateinfo).local();
return time;
      }
export const momentTime = (timeinfo) => {
  if (!timeinfo) return null;

  // Force parse as HH:mm (24-hour format)
  const time = moment.utc(timeinfo, "HH:mm", true); // true = strict mode
  return time.isValid() ? time : null;
};
export const  cleanBase64=(str)=> {
  // Remove whitespace and newlines
  let cleaned = str.replace(/\s/g, "");

  // Fix URL-safe base64 (if backend uses it)
  cleaned = cleaned.replace(/-/g, "+").replace(/_/g, "/");

  // Add padding if missing
  while (cleaned.length % 4 !== 0) {
    cleaned += "=";
  }

  return cleaned;
}



export const  getSlaTimeLeft=(slaexpire)=> {
  if (!slaexpire) return {due:false, text:""};

  // Parse date as UTC
  const expire = moment.utc(slaexpire);
  const now = moment.utc();

  const diffMs = expire.diff(now); // difference in ms

  if (diffMs <= 0) {
    // Already overdue
    const overdue = moment.duration(-diffMs); // make positive duration
    const days = Math.floor(overdue.asDays());
    const hours = overdue.hours();
    const minutes = overdue.minutes();

    if (days > 0) {
      return {due:true, text:`OVERDUE - ${days}d ${hours}h`};
    } else if (hours > 0) {
      return {due:true, text:`OVERDUE - ${hours}h ${minutes}m`};
    } else {
      return {due:true, text:`OVERDUE - ${minutes}m`};
    }
  } else {
    // Still time left
    const duration = moment.duration(diffMs);
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();

    if (days > 0) {
      return {due:false, text:`${days}d LEFT`};
    } else if (hours > 0) {
      return {due:false, text:`${hours}h ${minutes}m LEFT`};
    } else {
      return {due:false, text:`${minutes}m LEFT`};
    }
  }
}
